import { render, staticRenderFns } from "./default.vue?vue&type=template&id=79e1a507&scoped=true&"
import script from "./default.vue?vue&type=script&lang=js&"
export * from "./default.vue?vue&type=script&lang=js&"
import style0 from "./default.vue?vue&type=style&index=0&id=79e1a507&lang=scss&scoped=true&"
import style1 from "./default.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e1a507",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Navbar: require('/codebuild/output/src195787613/src/cc-portal/components/Navbar.vue').default,Sidebar: require('/codebuild/output/src195787613/src/cc-portal/components/Sidebar.vue').default})
